import React, { useState } from 'react';
import { useParams } from 'react-router';
import { handleFieldError, moveToFirstError } from 'libs/api/errorHandle';
import { sendCustomerOpinion } from 'libs/api/learning';
import { TModalProps } from 'modules/types';
import { Modal, Input, Button, Row, Form } from 'antd';
import { FormWrapper } from 'GlobalStyles';

type TSendingOpinion = {
  memo: string;
};

const SendingOpinionModal = ({ modalState, setModalState }: TModalProps) => {
  const { operation, id }: { operation: string; id: string } = useParams();
  const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false);
  const [form] = Form.useForm();

  function handleCancel() {
    setModalState({ visible: false });
    form.resetFields();
  }

  function handleSubmit() {
    form
      .validateFields()
      .then((value) => {
        handleSubmitOpinion(value as TSendingOpinion);
      })
      .catch((errorInfo) => moveToFirstError(form, errorInfo.errorFields));

    async function handleSubmitOpinion(value: TSendingOpinion) {
      try {
        setSubmitButtonDisabled(true);
        await sendCustomerOpinion({ body: value.memo, quiz_id: Number(id) });
        modalState.onFinish && modalState.onFinish();

        handleCancel();
      } catch (e) {
        handleFieldError(e, form);
        throw e;
      } finally {
        setSubmitButtonDisabled(false);
      }
    }
  }

  return (
    <Modal
      visible={modalState.visible}
      maskClosable={true}
      onCancel={handleCancel}
      width={680}
      centered={true}
      title={
        <div style={{ marginTop: '20px' }}>
          <span
            style={{
              fontSize: '1.5rem',
              fontWeight: 'bolder',
            }}
          >
            의견 보내기
          </span>
        </div>
      }
      footer={
        <Row justify='space-between'>
          <Button onClick={handleCancel}>취소</Button>
          <Button className='ant-btn-primary' loading={submitButtonDisabled} onClick={handleSubmit}>
            제출
          </Button>
        </Row>
      }
    >
      {/* <div>문제에 대한 의견 또는 오류에 대해서 자세히 적어주세요</div> */}
      <FormWrapper style={{ padding: '0 0px 20px' }}>
        <Form form={form} layout='vertical' className='form-normal'>
          <Form.Item
            name='memo'
            className='form-item no-margin'
            label='문제에 대한 의견 또는 오류에 대해서 자세히 적어주세요'
            rules={[{ required: true }]}
          >
            <Input.TextArea
              className='form_textarea'
              placeholder='문제에 대한 의견 또는 오류에 대해서 자세히 적어주세요'
              autoSize={{ minRows: 3 }}
            />
          </Form.Item>
        </Form>
      </FormWrapper>
    </Modal>
  );
};

export default SendingOpinionModal;
